<template>
  <div>
    <CaseTab :predmet_info="predmet_info" :current_tab="'Sudionici'" :mapped_permission="mapped_case_permission" />
    <div class="case-spisi">
      <div class="spisi-left sudionici-left">
        <!-- Close case-folders-line -->
        <div class="opening-folder opening-folder-sudionici">
          <div class="open-folder-line">
            <div class="open-folder-line-left switch-sudionici-wrapp">
              <label class="switch">
                <input type="checkbox" v-model="is_editable_sort">
                <span class="slider round"></span>

              </label>
              <span class="status-switch">{{ edit_status }}</span>

            </div>
            <div class="open-folder-line-right">
              <div class="sudionici-dropdown">
                Uloga:
                <select v-model="selected_uloga" @change="filterByUloga()" id="search-group"
                  :disabled="is_editable_sort">
                  <option value="all">Prikaži sve</option>
                  <option v-for="(uloga, key) in uloge" :key="key" :value="uloga">{{ uloga }}</option>
                </select>
                <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
              </div>
              <div class="sudionici-dropdown2">
                Spisi:
                <select v-model="selected_spis" @change="filterBySpis()" id="search-group" :disabled="is_editable_sort">
                  <option value="all">Prikaži sve</option>
                  <option :value="spis" v-for="(spis, key) in spisi" :key="key">
                    {{ spis.ime }}
                  </option>
                </select>
                <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
              </div>
            </div>
          </div>
          <div class="sudionici-main-wrapper">
            <div class="sudionici-row row-title-row">
              <div class="sudionici-column sudionici-column1">
                Sudionik
                <div class="downarrow"></div>
              </div>
              <div class="sudionici-column sudionici-column2">
                Status
                <div class="downarrow"></div>
              </div>
              <div class="sudionici-column sudionici-column3">
                Uloga
                <div class="downarrow"></div>
              </div>
              <div class="sudionici-column sudionici-column4">Dodan spisu</div>
              <div class="sudionici-column sudionici-column5"></div>
              <div class="sudionici-column sudionici-column6"></div>
            </div>
            <draggable class="sudionici-draggable" :sort="is_editable_sort" v-model="final_list_sudionici">
              <div class="sudionici-row" v-for="(person, key) in final_list_sudionici" :key="'10' + key">
                <router-link :to="person.person_type == 1 ? '/osobe/fiz/' + person.uid : '/osobe/prav/' + person.uid"
                  class="sudionici-column sudionici-column1">
                  <div class="edit-menu">
                    <input type="checkbox" />
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  {{ person.name }}
                </router-link>
                <div class="sudionici-column sudionici-column2">{{ person.status }}</div>
                <div class="sudionici-column sudionici-column3">
                  {{ person.role_id }}
                </div>
                <div class="sudionici-column sudionici-column4">
                  <div class="info-item-element" v-for="(spis, key) in spisi" :key="key">
                    {{ spis.ime }}
                  </div>
                </div>
              </div>
            </draggable>
            <div class="sudionici-row not-editable-sudionici" v-for="(sluzben, key) in final_sluzbene_osobe"
              :key="'50' + key">
              <router-link :to="'/osobe/leg-body/' + sluzben.sluzbena_osoba.uid"
                class="sudionici-column sudionici-column1">
                {{ sluzben.sluzbena_osoba.ime }}
                {{ sluzben.sluzbena_osoba.prezime }}
              </router-link>
              <div class="sudionici-column sudionici-column2">Sudionik</div>
              <div class="sudionici-column sudionici-column3">
                <div>
                  {{ sluzben.uloge[0] }}
                </div>
                <v-tooltip right v-if="
                  sluzben.uloge.length >
                  1
                ">
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                    <img v-bind="attrs" v-on="on" class="more-dots" src="@/assets/img/more.svg" />
                  </template>
                  <p v-for="(uloga, key) in sluzben.uloge" :key="key">{{ uloga }}</p>
                </v-tooltip>
              </div>
              <div class="sudionici-column sudionici-column4">
                <div v-for="(spis, key) in sluzben.spis" :key="key">
                  {{ spis }}
                </div>
              </div>
            </div>
            <div class="sudionici-row not-editable-sudionici" v-for="(odvjetnik, idx) in final_odvjetnici"
              :key="'60' + idx">
              <router-link :to="'/osobe/law/' + odvjetnik.odvjetnik.uid" class="sudionici-column sudionici-column1">
                {{ odvjetnik.odvjetnik.ime }} {{ odvjetnik.odvjetnik.prezime }}
              </router-link>
              <div class="sudionici-column sudionici-column2">Član tima</div>
              <div class="sudionici-column sudionici-column3">
                {{ odvjetnik.status_odvjetnik_predmet.naziv }}
              </div>
              <div class="sudionici-column sudionici-column4">
                <div v-for="(spis, key) in spisi" :key="key">
                  {{ spis.ime }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Close spisi-left -->
      <!-- <div class="spisi-right sudionici-right" v-if="is_right_visible">
        <div class="detalji-spisa section">
          <div class="section-title">
            {{ selected_pers.fullname }}
          </div>
          <div class="edit-detalji-spisa add-button add-pen">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
              <g>
                <g>
                  <path fill="#7b7b8a"
                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                </g>
              </g>
            </svg>
          </div>
          <div class="detalji-spisa-list">
            <div class="detalji-spisa-middle">
              <div class="case-info-item">
                <div class="case-info-item-title">Status:</div>
                <div class="case-info-item-info">
                  {{ selected_pers.status }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">Uloga:</div>
                <div class="case-info-item-info">{{ selected_pers.uloga }}</div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">U spisu:</div>
                <div class="case-info-item-info">
                  <span v-for="(sp, key) in selected_pers.popis_spisa" :key="'70' + key" class="tag">{{ sp.ime }}</span>
                </div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">OIB:</div>
              <div class="case-info-item-info">{{ selected_pers.oib }}</div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Adresa:</div>
              <div class="case-info-item-info" style="flex-direction:column;">
                <div v-for="(adr, key) in selected_pers.adresa" :key="'10' + key">{{ adr.adresa + ',' }} {{ adr.post_br
                    + ','
                }}
                  {{ adr.grad + ',' }} {{ adr.drzava }}</div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Tel:</div>
              <div class="case-info-item-info" style="flex-direction:column;">
                <div v-for="(t, key) in selected_pers.tel" :key="'10' + key">{{ t }}</div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Email:</div>
              <div class="case-info-item-info">
                <div v-for="(e, key) in selected_pers.email" :key="'10' + key">{{ e }}</div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Napomena:</div>
              <div class="case-info-item-info">
                {{ selected_pers.napomena }}
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import person from "@/apiCallers/person";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import auth from "@/services/auth";
import draggable from "vuedraggable";
import gsap from "gsap";
import { getCaseData, clearCaseData } from "@/router/case/handler"


export default {
  components: { CaseTab, draggable },
  data() {
    return {
      accessToken: "",
      selected_pers: {
        fullname: "",
        status: "",
        uloga: "",
        popis_spisa: [],
        oib: "",
        adresa: "",
        tel: "",
        email: "",
        napomena: "",
      },
      predmet_info: {broj_predmeta:''},

      final_fiz_ostali: [],
      final_prav_ostali: [],
      final_fiz_stranke: [],
      final_prav_stranke: [],
      final_fiz_protustranke: [],
      final_prav_protustranke: [],

      nadlezna_tijela: [],
      final_nadlezna_tijela: [],

      institucije: [],

      odvjetnici: [],
      final_odvjetnici: [],

      sluzbene_osobe: [],
      final_sluzbene_osobe: [],

      mapped_case_permission: [],

      list_of_sudionici: [],
      final_list_sudionici: [],
      is_editable_sort: false,
      is_list_filled: false,

      spisi: [],
      uloge: [],
      selected_spis: 'all',
      selected_uloga: 'all',
      is_right_visible: false,


      permission: {
        create: true,
        update: true,
        delete: true,
        read: true
      }
    };
  },
  computed: {
    edit_status: function () {
      return this.is_editable_sort ? "Uređivanje redosljeda sudionika" : "Pregled sudionika";
    }
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
    await getCaseData(this.$route.params.uid).then(async (response) => {
      let all_together = response;
      this.predmet_info = response;

      this.odvjetnici = all_together.predmet_odvjetnik_connector;
      this.sluzbene_osobe = all_together.spisi_people;
      this.institucije = all_together.connect_institucija_predmet;
      this.spisi = all_together.spis;

      this.final_fiz_stranke = all_together.connect_fiz_stranka;
      this.final_fiz_ostali = all_together.connect_fiz_ostali;
      this.final_prav_ostali = all_together.prav_connect_ostali;
      this.final_prav_stranke = all_together.prav_connect_stranka;
      this.final_fiz_protustranke = all_together.connect_fiz_protustranka;
      this.final_prav_protustranke = all_together.prav_connect_protustranka;
      this.final_sluzbene_osobe = this.sluzbene_osobe
      this.final_odvjetnici = this.odvjetnici



      if (this.predmet_info.sortable_participants.length > 0) {
        this.list_of_sudionici = this.predmet_info.sortable_participants
      } else {
        this.reverseEngineerIt()
      }
      this.final_list_sudionici = this.list_of_sudionici
      this.findAllUloge();
    });
    if (
      this.$store.state.logged_in_user == undefined ||
      this.$store.state.logged_in_user == null
    ) {
      await person.getSelf(this.accessToken).then((resp) => {
        this.$store.state.logged_in_user = resp.data;
      });
    }

    // console.log(this.accessToken)
  },
  watch: {
    final_list_sudionici: async function () {
      if (this.is_list_filled && this.is_editable_sort) {
        console.log("Napravila se izmjena", this.list_of_sudionici)
        predmet_hand.updateOrdering(this.$route.params.uid, this.final_list_sudionici)
        await clearCaseData();
      } else {
        this.is_list_filled = true;
      }

    },
    is_editable_sort() {
      if (this.is_editable_sort) {
        this.selected_spis = "all";
        this.selected_uloga = "all";
        this.filterByUloga()
        this.filterBySpis();
        gsap.to(".edit-menu", 0.5, { paddingRight: "20px", display: "block", opacity: 1 });
        gsap.to(".not-editable-sudionici", 0.5, {  opacity: 0.3 });

      }
      else {

        gsap.to(".edit-menu", 0.2, { paddingRight: "0px", opacity: 0, display: "none" });
        gsap.to(".not-editable-sudionici", 0.5, {  opacity: 1 });
      }
    }
  },
  methods: {

    reverseEngineerIt() {
      // primjer objekta
      // {
      //   "uid" : "",
      // "name" : "",
      // "person_type" : "",
      // "status" : "",
      // "role_id" :p.oznake_status.status_name
      // }
      // PERSON TYPE OZNAKE BROJEVA
      // fizičke osobe oznake 1
      // pravne osobe oznake 2

      this.list_of_sudionici = this.final_fiz_stranke.map((p) => ({
        "uid": p.fizicka_osoba.uid,
        "name": p.fizicka_osoba.ime + " " + p.fizicka_osoba.prezime,
        "person_type": 1,
        "status": "Stranka",
        "role_id": p.oznake_status.status_name

      }))

      this.list_of_sudionici = this.list_of_sudionici.concat(this.final_fiz_ostali.map((p) => ({
        "uid": p.fizicka_osoba.uid,
        "name": p.fizicka_osoba.ime + " " + p.fizicka_osoba.prezime,
        "person_type": 1,
        "status": "Drugi sudionik",
        "role_id": p.oznake_status.status_name
      })))
      this.list_of_sudionici = this.list_of_sudionici.concat(this.final_fiz_protustranke.map((p) => ({
        "uid": p.fizicka_osoba.uid,
        "name": p.fizicka_osoba.ime + " " + p.fizicka_osoba.prezime,
        "person_type": 1,
        "status": "Protustranka",
        "role_id": p.oznake_status.status_name
      })))


      this.list_of_sudionici = this.list_of_sudionici.concat(this.final_prav_ostali.map((p) => ({
        "uid": p.pravna_osoba.uid,
        "name": p.pravna_osoba.ime,
        "person_type": 2,
        "status": "Drugi sudionik",
        "role_id": p.oznake_status.status_name
      })))
      this.list_of_sudionici = this.list_of_sudionici.concat(this.final_prav_stranke.map((p) => ({
        "uid": p.pravna_osoba.uid,
        "name": p.pravna_osoba.ime,
        "person_type": 2,
        "status": "Stranka",
        "role_id": p.oznake_status.status_name
      })))
      this.list_of_sudionici = this.list_of_sudionici.concat(this.final_prav_protustranke.map((p) => ({
        "uid": p.pravna_osoba.uid,
        "name": p.pravna_osoba.ime,
        "person_type": 2,
        "status": "Protustranka",
        "role_id": p.oznake_status.status_name
      })))

      this.is_list_filled = true;

    },

    findAllUloge() {
      this.uloge = [];
      this.uloge = this.list_of_sudionici.map((el) => el.role_id)
      this.final_sluzbene_osobe.forEach((el) => this.uloge.push(...el.uloge))
      this.final_odvjetnici.forEach((el) => this.uloge.push(el.status_odvjetnik_predmet.naziv))
      this.uloge = [...new Set(this.uloge)];
    },
    filterByUloga() {
      this.selected_spis = 'all'
      if (this.selected_uloga != 'all') {
        this.final_list_sudionici = this.list_of_sudionici.filter((el) => el.role_id == this.selected_uloga);
        this.final_sluzbene_osobe = this.sluzbene_osobe.filter((el) => el.uloge.includes(this.selected_uloga));
        this.final_odvjetnici = this.odvjetnici.filter((el) => el.status_odvjetnik_predmet.naziv == this.selected_uloga);
      } else {
        this.final_list_sudionici = this.list_of_sudionici
        this.final_sluzbene_osobe = this.sluzbene_osobe
        this.final_odvjetnici = this.odvjetnici
      }

    },
    filterBySpis() {
      this.final_fiz_stranke = this.fiz_stranke
      this.final_prav_stranke = this.prav_stranke
      this.final_fiz_protustranke = this.fiz_protustranke
      this.final_prav_protustranke = this.prav_protustranke
      this.final_sluzbene_osobe = this.sluzbene_osobe
      this.final_odvjetnici = this.odvjetnici

      this.selected_uloga = 'all'
      if (this.selected_spis != 'all') {
        this.final_sluzbene_osobe = [];
        this.osobe = [];
        this.selected_spis.spis_sudionici_connector.forEach((s_o) => this.osobe.push(s_o.sluzbena_osoba.uid));
        this.final_sluzbene_osobe = this.sluzbene_osobe.filter((os) => this.osobe.includes(os.sluzbena_osoba.uid));
      }
      else {
        this.final_sluzbene_osobe = this.sluzbene_osobe
      }
    },
    goToPredmet(nastavak) {
      if (nastavak === "") {
        this.$router.push("/case/" + this.$route.params.uid + "/");
      } else this.$router.push(nastavak);
    },
  },
  mounted() { },
};
</script>

<style>
</style>